module.exports = __webpack_public_path__ + "img/icon_diamond.49a5203.webp";